import dynamic from 'next/dynamic';

import {
  CollectionCarouselProps,
  CollectionItem,
} from '@/components/organisms';
import { Chapter } from '@/lib/contexts/media-controller/util';
import { createImage } from '@/lib/utils/createImageObject';

import {
  WIDGET_TEMPLATES as TEMPLATES,
  WIDGET_TYPES as TYPES,
} from './constants';

import type { WidgetPlugin } from './types';

import type { Widget } from '@/lib/api/types';

export const SpotlightCollectionPlugin: WidgetPlugin<CollectionCarouselProps> =
  {
    type: TYPES.COLLECTION,
    template: TEMPLATES.BASIC,
    component: dynamic(() =>
      import('@/components/organisms').then(mod => mod.CollectionCarousel),
    ),
    mapProps: (widget: Widget) => {
      const originalType = widget.content_parameters.content_type;

      const linkType =
        originalType === 'podcast_chapter' ? 'podcast' : originalType;

      const isPodcast = linkType === 'podcast';

      const chapters = widget.template.items
        ? (widget.template.items.map(item => ({
            id: item.id,
            podcast_id: Number(item.podcast_id),
            image_url: item.image_url,
            title: item.name,
          })) as Chapter[])
        : [];

      const items: {
        id: string;
        image: string;
        title: string;
        link: string;
        type: string;
      }[] =
        widget.template?.items?.map(item => {
          return {
            id: item.id.toString(),
            image: item.art_work?.url ?? item.image_url ?? '',
            title: item.podcast_id ? (item.name ?? '') : item.title,
            link: '',
            type: linkType ?? '',
            rawData: isPodcast
              ? {
                  id: String(item.podcast_id),
                  chapters: chapters,
                }
              : undefined,
          };
        }) ?? [];

      const collectionLink = Array.isArray(widget.template?.parameters)
        ? undefined
        : `/collection/${widget.template?.parameters?.id}`;

      return {
        items: items as CollectionItem[],
        contentType: isPodcast
          ? 'podcast'
          : (widget.content_parameters.content_type as string),
        title: Array.isArray(widget.template.parameters)
          ? ''
          : (widget.template?.parameters?.title ?? ''),
        description: Array.isArray(widget.template.parameters)
          ? ''
          : (widget.template.parameters?.short_description ?? ''),
        buttonLabel: Array.isArray(widget.template.parameters)
          ? ''
          : (widget.template.parameters?.cta_title ?? ''),
        buttonLink: collectionLink?.toString() ?? '',
        imageLink: Array.isArray(widget.template.parameters)
          ? createImage()
          : createImage(widget.template.parameters?.image),
      };
    },
  };
